import { createAsyncThunk } from '@reduxjs/toolkit';
import { TimeZoneActions } from 'applicaiton/constants/actions';
import { AxiosError } from 'axios';
import { TimeZoneAPI } from 'integration/api/timeZone';

/**
 * Thunk action to set time zone data.
 *
 * @param timeZone - The time zone string to be set.
 * @returns A promise that resolves with the response data if successful, or rejects with an error message if unsuccessful.
 */
export const setTimeZoneData = createAsyncThunk(
  TimeZoneActions.setTimeZone,
  async (timeZone: string, { rejectWithValue }) => {
    try {
      const { data } = await TimeZoneAPI.setTimeZone(timeZone);
      return data;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);
